module.exports = __webpack_public_path__ + "img/cookie.9d1c6838.svg";